import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

// Public
export const getReviews = async () => {
  const res = await axios.get(`${API_BASE}/reviews`, {
    headers: { Accept: "application/json" },
    withCredentials: true, // include cookies if your server uses sessions
  });
  return res.data;
};

export const createReview = async (reviewData) => {
  const res = await axios.post(`${API_BASE}/reviews`, reviewData, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return res.data;
};

// 🧑‍💼 Admin-only

// DELETE /api/reviews/:id
export const deleteReview = async (id) => {
  const res = await axios.delete(`${API_BASE}/reviews/${id}`, {
    withCredentials: true, // important if using cookie-based auth
  });
  return res.data;
};

// POST /api/reviews/batch-delete
export const batchDeleteReviews = async (ids) => {
  const res = await axios.post(
    `${API_BASE}/reviews/batch-delete`,
    { ids },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return res.data;
};

// PATCH /api/reviews/:id/status  (optional for approve/reject)
export const updateReviewStatus = async (id, status) => {
  const res = await axios.patch(
    `${API_BASE}/reviews/${id}/status`,
    { status },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return res.data;
};
